import type {
  AccountingCandidate,
  ConflictDetail,
  ConflictListItem,
  ConflictResolutionRequest,
  ListConflictsQuery,
  ListConflictsResponse,
  SyncErrorEvent,
} from "@elastic/accounting-sync-api";
import crud from "@/api/crud";

export type {
  AccountingCandidate,
  ConflictDetail,
  ConflictListItem,
  ConflictResolutionRequest,
  ListConflictsQuery,
  SyncErrorEvent,
};

export const AccountingConflictsAPI = (baseUrl: string) => {
  return {
    list: async (id: number, query: ListConflictsQuery = {}) => {
      return (await crud.get(
        `${baseUrl}/accounting/integrations/${id}/conflicts`,
        Object.entries(query)
          .filter(([, value]) => value)
          .map(([key, value]) => ({ key, value })),
        true,
      )) as ListConflictsResponse;
    },
    get: async (id: number, conflictId: number) => {
      return (await crud.get(
        `${baseUrl}/accounting/integrations/${id}/conflicts/${conflictId}`,
        undefined,
        true,
      )) as ConflictDetail;
    },
    resolve: async (
      id: number,
      conflictId: number,
      body: ConflictResolutionRequest,
    ) => {
      return (await crud.post(
        `${baseUrl}/accounting/integrations/${id}/conflicts/${conflictId}/resolve`,
        body,
        true,
      )) as ConflictListItem;
    },
  };
};
